/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Get_Country, Get_Province} from './Property_Api'
import {FormikValues} from 'formik'
import {countryDataType, provinceDataType} from './PropertyDataTypes'
import Swal from 'sweetalert2'

const AddPropertyStep2 = ({formik}: FormikValues) => {
  const [country, setCountry] = useState<countryDataType[]>()
  const [province, setProvince] = useState<provinceDataType[]>([])

  // function to get country
  async function getCountry() {
    try {
      const {data: res} = await Get_Country()
      if (res.code === '200') {
        setCountry(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  // function to get Province/state
  async function getProvince(country: number) {
    try {
      const {data: res} = await Get_Province(country)
      if (res.code === '200') {
        setProvince(res.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  useEffect(() => {
    getCountry()
  }, [])

  // function to handle change in country
  const handleChangeCountry = (val: string) => {
    getProvince(Number(val))
    formik.setFieldValue('province_id', '', true)
    formik.setFieldValue('country_id', val, true)
  }
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*Begin::Form Group Address Line 1 */}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Address Line 1</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter complete address'
            ></i>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            name='address_1'
            placeholder='Enter address'
            {...formik.getFieldProps('address_1')}
          />
          <div className='h-20px'>
            {formik.touched.address_1 && formik.errors.address_1 && (
              <div className='fv-help-block color-red'>{formik.errors.address_1}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Address Line 1 */}
        {/*Begin::Form Group Address Line 2*/}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className=''>Address Line 2</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter complete address'
            ></i>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            name='address_2'
            placeholder='Enter address'
            {...formik.getFieldProps('address_2')}
          />
          <div className='h-20px'>
            {formik.touched.address_2 && formik.errors.address_2 && (
              <div className='fv-help-block color-red'>{formik.errors.address_2}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Address Line 2*/}
        <div className='d-flex w-100'>
          {/*Begin::Form Group Country*/}
          <div className='fv-row w-50 me-5 flex-fill'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Country</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose your country'
              ></i>
            </label>
            <select
              className='form-select form-select-solid'
              name='country_id'
              placeholder='Select country'
              {...formik.getFieldProps('country_id')}
              onChange={(e) => handleChangeCountry(e.target.value)}
            >
              <option className='bg-color-gray' value='' disabled>
                Select country
              </option>
              {country?.map((item) => {
                return (
                  <option key={item.country_id} value={item.country_id}>
                    {item.country_name}
                  </option>
                )
              })}
            </select>
            <div className='h-20px'>
              {formik.touched.country_id && formik.errors.country_id && (
                <div className='fv-help-block color-red'>{formik.errors.country_id}</div>
              )}
            </div>
          </div>
          {/*end::Form Group Country*/}
          {/*Begin::Form Group Province/State*/}
          <div className='fv-row w-50 flex-fill'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Province/State</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose your province/state'
              ></i>
            </label>
            <select
              className='form-select form-select-solid'
              name='province_id'
              placeholder='Select province/state'
              {...formik.getFieldProps('province_id')}
            >
              <option className='bg-color-gray' value='' disabled>
                Select province/state
              </option>
              {province.map((item) => {
                return (
                  <option key={item.province_id} value={item.province_id}>
                    {item.province_name}
                  </option>
                )
              })}
            </select>
            <div className='h-20px'>
              {formik.touched.province_id && formik.errors.province_id && (
                <div className='fv-help-block color-red'>{formik.errors.province_id}</div>
              )}
            </div>
          </div>
          {/*end::Form Group Province/State*/}
        </div>
        <div className='d-flex w-100'>
          {/*Begin::Form Group city*/}
          <div className='fv-row w-50 me-5 flex-basis-50'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>City</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter city name'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='city'
              placeholder='Enter city'
              {...formik.getFieldProps('city')}
            />
            <div className='h-20px'>
              {formik.touched.city && formik.errors.city && (
                <div className='fv-help-block color-red'>{formik.errors.city}</div>
              )}
            </div>
          </div>
          {/*end::Form Group city*/}
          {/*Begin::Form Group PIN/Postcode*/}
          <div className='fv-row w-50 flex-basis-50'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>PIN/Postcode</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter pincode'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='pin_zip'
              placeholder='Enter PIN/Postcode'
              {...formik.getFieldProps('pin_zip')}
            />
            <div className='h-20px'>
              {formik.touched.pin_zip && formik.errors.pin_zip && (
                <div className='fv-help-block color-red'>{formik.errors.pin_zip}</div>
              )}
            </div>
          </div>
          {/*end::Form Group PIN/Postcode*/}
        </div>
      </div>
    </div>
  )
}

export default AddPropertyStep2
